export default __webpack_public_path__ + "3ac712864269c3a51f88b4d92482903a.png";